import type {DayJsObject} from "../../utils/day-js-utils.ts";
import type {Dayjs} from 'dayjs';
import dayjs from 'dayjs';
import type {DateRange, PickersShortcutsItem} from "@mui/x-date-pickers-pro";

const today = dayjs();
const currentMonth = today.get('month')
const currentYear = today.get('year')
const lastYear = currentYear - 1;

const quarterStartMonth = Math.floor(currentMonth / 3) * 3; // Find the start month of the current quarter
const prevQuarterStartMonth = quarterStartMonth - 3 < 0 ? 9 : quarterStartMonth - 3; // Find the start month of the last quarter
const prevQuarterYear = prevQuarterStartMonth > currentMonth ? lastYear : currentYear; // Year of the last quarter

function getQuarterRange(quarter: number, year: number): DateRange<Dayjs> {
    return [
        dayjs({month: (quarter - 1) * 3, year} satisfies DayJsObject),
        dayjs({month: quarter * 3 - 1, year} satisfies DayJsObject).endOf('month'),
    ]
}

export const DATE_RANGE_SHORTCUTS_QUARTERS: PickersShortcutsItem<DateRange<Dayjs>>[] = [
    {
        label: 'Current Quarter',
        getValue: () => [
            dayjs({month: quarterStartMonth, year: currentYear} satisfies DayJsObject),
            dayjs({month: quarterStartMonth + 2, year: currentYear} satisfies DayJsObject).endOf('month'),
        ],
    },
    {
        label: 'Last Quarter',
        getValue: () => [
            dayjs({month: prevQuarterStartMonth, year: prevQuarterYear} satisfies DayJsObject),
            dayjs({month: prevQuarterStartMonth + 2, year: prevQuarterYear} satisfies DayJsObject).endOf('month'),
        ],
    },
    {
        label: 'This Month',
        getValue: () => [
            dayjs({month: currentMonth, year: currentYear} satisfies DayJsObject),
            dayjs({month: currentMonth, year: currentYear} satisfies DayJsObject).endOf('month'),
        ],
    },
    {
        label: 'Last Month',
        getValue: () => [
            today.subtract(1, 'month').startOf('month'),
            today.subtract(1, 'month').endOf('month'),
        ],
    },
    {
        label: 'Year to Date',
        getValue: () => [today.subtract(1, 'year'), today],
    },
    {
        label: 'Last Year',
        getValue: () => [
            today.subtract(1, 'year').startOf('year'),
            today.subtract(1, 'year').endOf('year'),
        ],
    },
    {
        label: `Q1 ${lastYear}`,
        getValue: () => getQuarterRange(1, lastYear),
    },
    {
        label: `Q2 ${lastYear}`,
        getValue: () => getQuarterRange(2, lastYear),
    },
    {
        label: `Q3 ${lastYear}`,
        getValue: () => getQuarterRange(3, lastYear),
    },
    {
        label: `Q4 ${lastYear}`,
        getValue: () => getQuarterRange(4, lastYear),
    },
    {label: 'Clear', getValue: () => [null, null]},
];
